import { Box, Skeleton, Tab, Tabs } from "@mui/material";
import { useEffect, useState } from "react";
import RangeDatePicker from "shared/components/rangeDatePicker";
import styles from "./style.module.scss";
import StatsCard from "shared/components/statsCard";
import classNames from "classnames";
import MultiAxisLineChart from "shared/components/lineGraph";
import useBreadcrumbs from "shared/customHooks/useBreadCrumbs";
import { routeConstant } from "shared/routes/routesConstant";
import {
  earningDetailGraphs,
  earningDetailStats,
} from "shared/services/projectHeadService";
import moment from "moment";

function EarningDetails() {
  const [activeTab, setActiveTab] = useState<any>(0);
  const [startDate, setStartDate] = useState<Date | null>(null);
  const [endDate, setEndDate] = useState<Date | null>(new Date());
  const [loader, setLoader] = useState<boolean>(false);
  const [stats, setStats] = useState<any>(null);
  const [graphData, setGraphData] = useState<any>({});
  const [graphLoader, setGraphLoader] = useState<boolean>(false);

  let statsCard = [
    {
      label: "Total Income from plans",
      count: `Rs ${stats?.plans?.toLocaleString()}`,
    },
    {
      label: "Total income from top-up balance",
      count: `Rs ${stats?.topups?.toLocaleString()}`,
    },
    {
      label: "Earning through platform",
      count: `Rs ${stats?.platform_earning?.toLocaleString()}`,
    },
    {
      label: "Aliflaila Profit",
      count: `Rs ${stats?.alif_laila_profit?.toFixed(2)?.toLocaleString()}`,
    },
    {
      label: "Unused Coins",
      count: `${Number(stats?.unused_coins)}`,
    },
    {
      label: "Payable pending amount",
      count: "__",
    },
  ];

  const tabs = [
    {
      value: 0,
      label: "Total Income",
    },
    {
      value: 1,
      label: "Earning through platform",
    },
    {
      value: 2,
      label: "Alifliala Profit",
    },
  ];

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setActiveTab(newValue);
  };

  useBreadcrumbs(
    {
      title: "Total Earnings",
      path: routeConstant.earningDetail.path,
    },
    true
  );

  let dataSetsForGraphs = [
    {
      label: "Income through plans",
      data: [10, 5, 16, 15, 14, 20, 10],
      borderColor: "#EF437B",
      backgroundColor: "#EF437B",
      pointRadius: 5,
      pointHoverRadius: 7,
      pointBorderColor: "rgba(0, 0, 0, 0)",
      pointBackgroundColor: "rgba(0, 0, 0, 0)",
      pointHoverBackgroundColor: "#EF437B",
      pointHoverBorderColor: "#FFFFFF",
    },
    {
      label: "Income through top ups",
      data: [40, 20, 25, 20, 6, 40, 33],
      borderColor: "#1897A6",
      backgroundColor: "#1897A6",
      pointRadius: 5,
      pointHoverRadius: 7,
      pointBorderColor: "rgba(0, 0, 0, 0)",
      pointBackgroundColor: "rgba(0, 0, 0, 0)",
      pointHoverBackgroundColor: "#1897A6",
      pointHoverBorderColor: "#FFFFFF",
    },
    {
      label: "All Income",
      data: [34, 12, 15, 5, 10, 12, 17],
      borderColor: "#FDA504",
      backgroundColor: "#FDA504",
      pointRadius: 5,
      pointHoverRadius: 7,
      pointBorderColor: "rgba(0, 0, 0, 0)",
      pointBackgroundColor: "rgba(0, 0, 0, 0)",
      pointHoverBackgroundColor: "#FDA504",
      pointHoverBorderColor: "#FFFFFF",
    },
  ];

  const getStats = () => {
    setLoader(true);
    earningDetailStats({
      from: moment(startDate).format("YYYY-MM-DD"),
      to: moment(endDate).format("YYYY-MM-DD"),
    })
      .then(({ data }) => {
        setStats(data?.data);
        setLoader(false);
      })
      .catch((err) => {
        console.log("err", err?.response?.data?.message);
        setLoader(false);
      });
  };

  const getGraphs = () => {
    setGraphLoader(true);
    earningDetailGraphs(
      {
        from: moment(startDate).format("YYYY-MM-DD"),
        to: moment(endDate).format("YYYY-MM-DD"),
      },
      activeTab === 0
        ? "total_income"
        : activeTab === 2
        ? "platform"
        : "aliflaila_income"
    )
      .then(({ data }) => {
        setGraphData(data?.data);
        setGraphLoader(false);
      })
      .catch((err) => {
        console.log("err", err?.response?.data?.message);
        setGraphLoader(false);
      });
  };

  useEffect(() => {
    if (startDate && endDate) {
      getStats();
    }
    //eslint-disable-next-line
  }, [startDate, endDate]);

  useEffect(() => {
    if (startDate && endDate) {
      getGraphs();
    }
    //eslint-disable-next-line
  }, [startDate, endDate, activeTab]);

  console.log("stats", stats);

  return (
    <div className={styles.mainContainer}>
      <Box className={styles.headingContainer}>
        <div>
          <span className={styles.heading}>
            Total Rs. {stats?.total?.toFixed(2)} in Account
          </span>
        </div>
        <div>
          <div className={styles.dateContainer}>
            <RangeDatePicker
              startDate={startDate}
              setStartDate={setStartDate}
              endDate={endDate}
              setEndDate={setEndDate}
              doubleLabel={true}
            />
          </div>
        </div>
      </Box>

      <StatsCard
        statsList={statsCard}
        label={"Earnings Details"}
        loader={loader}
      />

      <Box>
        <Tabs
          value={activeTab}
          onChange={handleChange}
          className={styles.tab}
          TabIndicatorProps={{
            style: {
              backgroundColor: "black",
            },
          }}
          sx={{
            "& .MuiTabs-flexContainer": {
              borderBottom: "1.5px solid #D9D9D9",
            },
          }}
        >
          {tabs?.map((item: any, index: any) => {
            return (
              <Tab
                label={
                  <div
                    className={classNames(
                      styles.tabs,
                      activeTab === item?.value && styles.active
                    )}
                  >
                    <label className={styles.tabLabel}> {item?.label}</label>
                  </div>
                }
              />
            );
          })}
        </Tabs>
      </Box>

      <div className={styles.graphContainer}>
        <div>
          {graphLoader ? (
            <Skeleton variant="rectangular" width={"100%"} height={400} />
          ) : (
            <MultiAxisLineChart
              datasets={dataSetsForGraphs}
              canvasStyle={styles.canvas}
              legend={false}
              responsive={true}
              labels={graphData?.labels}
            />
          )}
        </div>
      </div>
    </div>
  );
}

export default EarningDetails;
